<template>
  <div style="height: 100%; width: 100%">
    <gmap-map
      :center="center"
      :zoom="14"
      style="width:100%;  height: 100%;"
      :clickable-icons="true"
      :options="{
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        gestureHandling: 'greedy',
        maxZoom: 17,
        styles: mapStyles,
      }"
    >
      <gmap-marker
        v-for="(c) in currentPlaceMarker"
        :position="c.position"
        :clickable="false"
        :icon="{ url: require('../../assets/img/pins/ubic.gif')}"
        @click="center=c.position"
      />

      <gmap-marker
        v-for="(m) in availableStores"
        :key="m.id"
        :ref="m.id"
        :position="m.position"
        :clickable="true"
        :icon="{ url: getStoreMarkerIcon(m, 'opened') }"
        :animation="0"
        @click="selectMarker(m, 'mapSelect')"
      />

      <gmap-marker
        v-for="(m) in notAvailableStores"
        :key="m.id"
        :ref="m.id"
        :position="m.position"
        :clickable="true"
        :icon="{ url: getStoreMarkerIcon(m, 'closed')}"
        :opacity="90"
        :animation="0"
        @click="selectMarker(m, 'mapSelect')"
      />
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: 'MapComponent',

  props: {
    place: {
      type: Object,
      default: {},
    },
    storesList: {
      type: Array,
      default: [],
    },
    selectedStoreCard: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      center: { lat: -34.6015, lng: -58.3855 },
      availableStores: [],
      notAvailableStores: [],
      stores: null,
      currentPlaceMarker: [],
      selectStoreCard: {},
      mapStyles: [
        {
          featureType: 'poi.business',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.medical',
          stylers: [
            {
              visibility: 'simplified',
            },
            {
              weight: 1.5,
            },
          ],
        },
        {
          featureType: 'poi.medical',
          elementType: 'labels',
          stylers: [
            {
              color: '#78909c',
            },
          ],
        },
        {
          featureType: 'poi.medical',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.place_of_worship',
          stylers: [
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'poi.school',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.sports_complex',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ],
    };
  },

  watch: {
    place() {
      this.addPlaceMarker();
    },

    storesList(newStores) {
      if (newStores != null) {
        this.availableStores = [];
        this.notAvailableStores = [];

        this.stores = newStores;
        this.addStoresMarkers();
      }
    },

    selectedStoreCard(newSelection) {
      if (newSelection != null) {
        this.selectStoreCard = newSelection;
        this.selectMarker(newSelection, 'cardSelect');
      }
    },

  },

  mounted() {
    this.addPlaceMarker();
    this.stores = this.storesList;
  },

  methods: {

    getStoreMarkerIcon(store, status) {
      if (status === 'opened') {
        if (store.is_locker) {
          return require('../../assets/img/pins/locker-open.png');
        }
        return require('../../assets/img/pins/store-open.png');
      }

      if (store.is_locker) {
        return require('../../assets/img/pins/locker-closed.png');
      }
      return require('../../assets/img/pins/store-closed.png');
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    addPlaceMarker() {
      if (this.place) {
        this.currentPlaceMarker = [];

        if (typeof this.place.geometry.location.lat === 'function') {
          const marker = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          };
          this.currentPlaceMarker.push({ position: marker });
          this.center = marker;
        } else {
          const marker = {
            lat: this.place.geometry.location.lat,
            lng: this.place.geometry.location.lng,
          };
          this.currentPlaceMarker.push({ position: marker });
          this.center = marker;
        }
      }
    },

    addStoresMarkers() {
      if (this.stores != null) {
        const context = this;

        this.stores.forEach((store) => {
          const storeForMap = store;

          storeForMap.position = {
            lat: parseFloat(store.latitude_coordinate),
            lng: parseFloat(store.longitude_coordinate),
          };

          if (storeForMap.isAvailable) {
            context.availableStores.push(storeForMap);
          } else {
            context.notAvailableStores.push(storeForMap);
          }
        });
      }
    },

    selectMarker(store, type) {
      this.center = {
        lat: parseFloat(store.latitude_coordinate),
        lng: parseFloat(store.longitude_coordinate),
      };

      if (this.previewSelect && this.previewSelect !== store.id) {
        this.$refs[this.previewSelect][0].$markerObject.setAnimation(google.maps.Animation.NULL);
      }
      this.previewSelect = store.id;
      this.$refs[store.id][0].$markerObject.setAnimation(google.maps.Animation.BOUNCE);

      if (type === 'mapSelect') {
        this.$emit('selectedStoreMap', store, 'map');
      }
    },
  },
};
</script>
